import { accessibilityPreferences } from '$lib/stores/accessibility';
import { writable, derived } from 'svelte/store';

export const TransitionStatus = writable({
  isTransitioning: false
});

export const duration = derived(accessibilityPreferences, ($accessibilityPreferences) => {
  return $accessibilityPreferences.reduceMotion ? 1 : 500;
});

export const delay = derived(accessibilityPreferences, ($accessibilityPreferences) => {
  return $accessibilityPreferences.reduceMotion ? 1 : 300;
});
